import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=18a84a85&scoped=true&"
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=18a84a85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a84a85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18a84a85')) {
      api.createRecord('18a84a85', component.options)
    } else {
      api.reload('18a84a85', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=18a84a85&scoped=true&", function () {
      api.rerender('18a84a85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/chartjs/PieChart.vue"
export default component.exports